import React, { useEffect } from "react";
import { FormGroup, FormLabel, FormControl } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import Switch from "components/Switch";
import EmployeeFilter from "../filters/EmployeeFilter";
import GroupFilter from "../filters/GroupFilter";
import { useAttendance } from "../../../hooks/attendance/AttendanceContext";
import { TIME_LIST_VIEWS } from "pages/AttendanceSupervisor";

/**
 * Bottom sheet con los filtros secundarios y ajustes.
 * Reutiliza los mismos filtros empleado/grupo que la vista desktop.
 */
const MobileAttendanceFiltersSheet = ({ open, onClose, timeListView }) => {
	const { t } = useTranslation();
	const { filters } = useAttendance();
	const {
		notEnded,
		showApproved,
		showAlerts,
		showRestTime,
		toggleFilter,
		setFilterAlerts,
	} = filters;

	useEffect(() => {
		if (!open) return undefined;
		const prev = document.body.style.overflow;
		document.body.style.overflow = "hidden";
		return () => {
			document.body.style.overflow = prev;
		};
	}, [open]);

	if (!open) return null;

	const isNotEndedOn = notEnded === "1" || notEnded === true;
	const isUnapprovedOn = showApproved === "1" || showApproved === true;

	const handleSwitch = (key) => () => {
		if (key === "not_ended") {
			toggleFilter("not_ended", !isNotEndedOn ? "1" : "0");
		} else if (key === "filter_approved") {
			toggleFilter("filter_approved");
		} else if (key === "show_rest_time") {
			toggleFilter("show_rest_time", !showRestTime);
		}
	};

	return (
		<div
			className="mobile-attendance-sheet-backdrop"
			onClick={onClose}
			role="presentation"
		>
			<div
				className="mobile-attendance-sheet"
				onClick={(e) => e.stopPropagation()}
				role="dialog"
				aria-label={t("attendance.filters")}
			>
				<div className="mobile-attendance-sheet__header">
					<h3 className="mobile-attendance-sheet__title">{t("attendance.filters")}</h3>
					<button
						type="button"
						className="mobile-attendance-sheet__close"
						onClick={onClose}
						aria-label={t("common.close")}
					>
						<FiX size={22} />
					</button>
				</div>

				<div className="mobile-attendance-sheet__body">
					<div className="mobile-attendance-sheet__field">
						<label className="mobile-attendance-sheet__label">{t("common.employee")}</label>
						<EmployeeFilter />
					</div>

					<div className="mobile-attendance-sheet__field">
						<label className="mobile-attendance-sheet__label">{t("common.group")}</label>
						<GroupFilter />
					</div>

					<div className="mobile-attendance-sheet__switches">
						{timeListView === TIME_LIST_VIEWS.employee_day && (
							<FormGroup
								className="form-group form-group-flex form-switch"
								controlId="m_show_rest_time"
							>
								<Switch
									controlId="m_show_rest_time"
									isOn={showRestTime}
									handleToggle={handleSwitch("show_rest_time")}
								/>
								<FormLabel className="mb-1">{t("times.filter.showRest")}</FormLabel>
							</FormGroup>
						)}

						<FormGroup
							className="form-group form-group-flex form-switch"
							controlId="m_not_ended"
						>
							<Switch
								controlId="m_not_ended"
								isOn={isNotEndedOn}
								handleToggle={handleSwitch("not_ended")}
							/>
							<FormLabel className="mb-1">{t("times.filter.showOpen")}</FormLabel>
						</FormGroup>

						<FormGroup
							className="form-group form-group-flex form-switch"
							controlId="m_filter_approved"
						>
							<Switch
								controlId="m_filter_approved"
								isOn={isUnapprovedOn}
								handleToggle={handleSwitch("filter_approved")}
							/>
							<FormLabel className="mb-1">{t("times.filter.showPending")}</FormLabel>
						</FormGroup>

						<FormGroup
							className="form-group form-group-side"
							controlId="m_filter_alerts"
						>
							<FormLabel>{t("times.filter.alerts")}</FormLabel>
							<FormControl
								as="select"
								value={showAlerts}
								onChange={(e) => setFilterAlerts(e.target.value)}
							>
								<option value="-1">{t("times.filter.showAll")}</option>
								<option value="0">{t("attendance.noAlerts")}</option>
								<option value="1">{t("attendance.withAlerts")}</option>
							</FormControl>
						</FormGroup>
					</div>
				</div>

				<div className="mobile-attendance-sheet__footer">
					<button
						type="button"
						className="btn btn-primary"
						onClick={onClose}
					>
						{t("common.apply")}
					</button>
				</div>
			</div>
		</div>
	);
};

export default MobileAttendanceFiltersSheet;
